export enum ProductDependencyActionType {
	INCLUDES = "Includes",
	REQUIRES = "Requires",
	EXCLUDES = "Excludes",
	OPTIONAL = "Optional",
	ENABLE = "Enable",
	DISABLE = "Disable",
	CLEAR = "Clear"
}
